<div class="field field-date {{classes}}" [ngStyle]="{'width': width ? width : ''}">
  @if (label) {
    <span class="label" [class.disabled]="disabledLabel">{{label}}@if (optionalString) {
      <span>({{optionalString}})</span>
      }@if (tooltipObj) {
      <app-tooltip-label [tooltipObj]="tooltipObj"></app-tooltip-label>
    }</span>
  }
  @if (ready) {
    <div class="w-100 position-relative">
      <input
        [ngStyle]="{'width': width ? width : ''}"
        #myinput
        [class.error-field]="error"
        [placeholder]="placeholder"
        (calendarToggle)="calendarToggle($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        (dateSelect)="onDateChanged($event)"
        [(ngModel)]="localModel"
        [autocomplete]="autocomplete"
        [class.disabled]="disabled"
        [disabled]="disabled"
        ngbDatepicker
        (click)="!disabled ? d.toggle() : ''"
        [minDate]="localDisableUntil"
        [maxDate]="localDisableSince"
        #d="ngbDatepicker"/>
    </div>
  }
  @if (error) {
    <span class="error-field-display">{{error}}</span>
  }
</div>